"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tab = _interopRequireDefault(require("@mui/material/Tab"));
var _Tabs = _interopRequireDefault(require("@mui/material/Tabs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A more approachable wrapper around Material UI's `Tabs` system
 * 
 * Original author @heron-web/material (no longer maintained)
 */class TabPanel extends _react.default.PureComponent {
  /**
   * Selected tab changed.
   *
   * @param {Event} e
   * @param {mixed} v Tab's `value`
   * @return {void}
   */
  handleChange = (e, v) => {
    this.props.onChange(v, this.props.name);
  };

  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    const tabs = this.tabs;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      columnar: this.props.vertical,
      gap: this.props.gap,
      ...this.props.FlexProps,
      children: tabs?.length ? this.renderTabs(tabs) : this.props.noTabsState && _ReactUtils.default.render(this.props.noTabsState) || null
    });
  }

  /**
   * Render the `Tabs` of a set of tabs.
   *
   * @param {Array} tabs Tab objects
   * @return {ReactNode}
   */
  renderTabs(tabs) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        alignItems: "center",
        columnar: !this.props.isMobile,
        justifyContent: "space-between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
          alignItems: "center",
          columnar: !this.props.isMobile,
          justifyContent: "flex-start",
          children: [this.props.preContent ? this.props.preContent : undefined, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tabs.default, {
            centered: this.props.centred,
            className: this.props.className,
            indicatorColor: this.props.color,
            onChange: this.handleChange,
            orientation: this.props.vertical ? "vertical" : undefined,
            scrollButtons: "auto",
            textColor: this.props.textColor,
            value: this.props.value,
            variant: this.props.variant,
            ...this.props.TabsProps,
            children: [tabs.map((tab, key) => {
              const tabId = this.constructor.getTabId(tab, key);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab.default, {
                disabled: tab.disabled || this.props.disabled,
                icon: tab.icon ? _ReactUtils.default.render(tab.icon) : undefined,
                label: tab.label,
                value: tabId,
                ...this.props.TabProps
              }, key);
            }), this.props.children]
          })]
        }), this.props.postContent ? this.props.postContent : undefined]
      }), this.renderTabContent(tabs)]
    });
  }

  /**
   * Get the currently selected tab object from our tabs or a set of tabs.
   *
   * Always uses the active tab indicated by our `value` prop.
   *
   * @param {Array} tabs undefined Tab objects; defaults to `tabs`
   * @return {Object|undefined}
   */
  getSelectedTab(tabs = undefined) {
    return (tabs || this.tabs).find((tab, i) => this.constructor.getTabId(tab, i) === this.props.value);
  }

  /**
   * Render the active tab's content.
   *
   * The active tab is indicated by our `value` prop and must 
   * be included in the passed `tabs` array of tab objects.
   * 
   * @param {Array} tabs Tab objects
   * @return {ReactNode}
   */
  renderTabContent(tabs) {
    const tab = this.getSelectedTab(tabs);
    return tab?.render?.(tab?.id) || tab?.component && _ReactUtils.default.render(tab.component, tab.componentProps || {}) || null;
  }

  /**
   * Get currently available tabs.
   * 
   * @return {Array}
   */
  get tabs() {
    return this.props.tabs.filter(tab => !tab.hidden);
  }

  /**
   * Get the internal ID (value) of a tab object.
   *
   * Uses the tab's `id` field when it's set or `index` - which 
   * should be its index in our overall `tabs` array - otherwise.
   *
   * @param {Object} tab
   * @param {Integer} index
   * @return {mixed}
   */
  static getTabId(tab, index) {
    return tab.id !== undefined ? tab.id : index;
  }
  static propTypes = {
    FlexProps: _propTypes.default.object,
    TabProps: _propTypes.default.object,
    TabsProps: _propTypes.default.object,
    centred: _propTypes.default.bool,
    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node)], _propTypes.default.node),
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    gap: _propTypes.default.number,
    name: _propTypes.default.string,
    noTabsState: _propTypes.default.elementType,
    onChange: _propTypes.default.func,
    tabs: _propTypes.default.array,
    textColor: _propTypes.default.oneOf(["inherit", "primary", "secondary"]),
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.oneOf([false])]),
    variant: _propTypes.default.oneOf(["standard", "scrollable", "fullWidth"]),
    vertical: _propTypes.default.bool
  };
  static defaultProps = {
    color: "primary",
    gap: 2,
    textColor: "primary",
    variant: "standard",
    vertical: false
  };
}
var _default = exports.default = (0, _withMobile.default)(TabPanel);